import React, { Suspense } from 'react';
import RedirectToHome from 'pages/main/redirect_to_home';
import { ComponentForSeedlangOrMemrevSite } from 'utils/component_for_seedlang_or_memrev_site';
import WorksheetInfo from 'components/worksheet/worksheet_info';

// app
import Onboarding from 'components/onboarding/onboarding';
import OnboardingLevel from 'components/onboarding/onboarding_level';
import OnboardingRegistration from 'components/onboarding/onboarding_registration';
import OnboardingMemrevMigration from 'components/onboarding/onboarding_memrev_migration';
import OnboardingReferrer from 'components/onboarding/onboarding_referrer';
import OnboardingNativeLanguage from 'components/onboarding/onboarding_native_language';
import OnboardingChooseDeck from 'components/onboarding/onboarding_choose_deck';
import OnboardingMemrevCreatePassword from 'components/onboarding/onboarding_memrev_create_password';
import AuthenticateExists from 'components/authenticate/authenticate_exists';
import App from 'pages/app';
import ProfileHome from 'components/profile/profile_home';
import Settings from 'components/user/settings';
import Faq from 'pages/main/faq';
import UnpublishedMemrevHome from 'pages/main/unpublished_memrev_home';
import Access from 'pages/main/access';
import HelpCenter from 'pages/main/help_center';
import FaqCategoryShow from 'components/faq_category/faq_category_show';
import FaqItemShow from 'components/faq_item/faq_item_show';
import More from 'components/profile/more';
import LatestDecks from 'components/profile/latest_decks';
import CommentHistory from 'components/profile/comment_history';
import ContactSeedlang from 'pages/main/contact_seedlang';
import ContactMemrev from 'pages/main/contact_memrev';
import Community from 'pages/main/community';
import AccountDeletion from 'pages/main/account_deletion';
import SettingsDeck from 'components/user/settings_deck';
import SettingsClearProgress from 'components/user/settings_clear_progress';
import SettingsStreakRepair from 'components/user/settings_streak_repair';
import SettingsUserImage from 'components/user/settings_user_image';
import SettingsUserNotifications from 'components/user/settings_user_notifications';
import SettingsEmail from 'components/user/settings_email';
import SettingsBillingSeedlang from 'components/user/settings_billing_seedlang';
import SettingsBillingMemrev from 'components/user/settings_billing_memrev';
import SettingsAffiliate from 'components/user/settings_affiliate';
import SettingsPassword from 'components/user/settings_password';
import SettingsCancel from 'components/user/settings_cancel';
import SettingsRssFeed from 'components/user/settings_rss_feed';
import SettingsPrivacy from 'components/user/settings_privacy';
import SettingsUserProfileSeedlang from 'components/user/settings_user_profile_seedlang';
import SettingsUserProfileMemrev from 'components/user/settings_user_profile_memrev';
import DeckShow from 'components/deck/deck_show';
import TreeNodeShow from 'components/tree_node/tree_node_show';
import ReviewProgress from 'components/review/review_progress';
import ReviewShow from 'components/review/review_show';
import Review from 'components/review/review';
import MembershipIndex from 'components/membership/membership_index';
import MembershipChange from 'components/membership/membership_change';
import CheckoutSeedlang from 'components/checkout/checkout_seedlang';
import CheckoutMemrev from 'components/checkout/checkout_memrev';
import ReviewHome from 'components/review/review_home';
import VocabHome from 'components/vocab/vocab_home';
import ThankYou from 'components/checkout/thank_you';
import Stories from 'components/stories/stories';
import StoriesProgress from 'components/stories/stories_progress';
import StoriesHome from 'components/stories/stories_home';
import Vocab from 'components/vocab/vocab';
import VocabWord from 'components/vocab/vocab_word';
import VocabCreate from 'components/vocab/vocab_create';
import Trivia from 'components/trivia/trivia';
import TriviaHome from 'components/trivia/trivia_home';
import TriviaProgress from 'components/trivia/trivia_progress';
import Landing from 'components/landing/landing';
import VocabProgress from 'components/vocab/vocab_progress';
import Maintenance from 'pages/main/maintenance';
import Discord from 'pages/main/discord';
import AssignMembershipGroup from 'components/membership/assign_membership_group';
import LeagueShow from 'components/league/league_show';

// translator
import Translator from 'pages/translator/translator';
import TranslatorHome from 'pages/translator/translator_home';
import TranslatorWords from 'pages/translator/translator_words';
import TranslatorSentencesIndex from 'pages/translator/translator_sentences_index';
import TranslatorDecksIndex from 'pages/translator/translator_decks_index';
import TranslatorDecksShow from 'pages/translator/translator_decks_show';
import TranslatorUsers from 'pages/translator/translator_users';
import TranslatorUser from 'pages/translator/translator_user';

// classroom
import BackendClassroom from 'pages/classroom/classroom';
import ClassroomDashboard from 'pages/classroom/classroom_dashboard';
import ClassroomSettings from 'pages/classroom/classroom_settings';
import ClassroomStudents from 'pages/classroom/classroom_students';

// not for app
import UserResetPassword from 'components/user/user_reset_password';
import GroupShow from 'components/group/group_show';
import WorksheetShow from 'components/worksheet/worksheet_show';
import WorksheetComments from 'components/worksheet/worksheet_comments';
import ExerciseShow from 'components/exercise/exercise_show';
import WorksheetVocab from 'components/worksheet/worksheet_vocab';
import GroupInfo from 'components/group/group_info';
import ExerciseIndex from 'components/exercise/exercise_index';
import WorksheetIndex from 'components/worksheet/worksheet_index';
import Forum from 'pages/main/forum';
import ForumIndex from 'components/forum/forum_index';
import ForumShowBase from 'components/forum/forum_show';
import ForumThreadShowBase from 'components/forum_thread/forum_thread_show';
import ForumThreadCreateBase from 'components/forum_thread/forum_thread_create';
import Feed from 'pages/main/feed';
import FeedEntryShow from 'components/feed/feed_entry_show';
import AppListing from 'pages/main/app_listing';
import Privacy from 'pages/main/privacy';
import Partners from 'pages/main/partners';
import Legal from 'pages/main/legal';
import Terms from 'pages/main/terms';
import Team from 'pages/main/team';
import JobsIndex from 'components/jobs/jobs_index';
import JobsShow from 'components/jobs/jobs_show';
import PodcastEpisodeShow from 'pages/main/podcast_episode_show';
import Blog from 'pages/blog/blog';
import Classroom from 'components/classroom/classroom';
import ClassroomShow from 'components/classroom/classroom_show';
import ClassroomProgress from 'components/classroom/classroom_progress';
import Grammar from 'components/grammar/grammar';
import GrammarHome from 'components/grammar/grammar_home';
import GrammarIndex from 'components/grammar/grammar_index';
import VideoWorksheetIndex from 'components/worksheet/video_worksheet_index';
import PodcastWorksheetIndex from 'components/worksheet/podcast_worksheet_index';
import DownloadLinkIndex from 'components/download_link/download_link_index';
import BlockNotifications from 'pages/main/block_notifications';
import ExitSurvey from 'pages/main/exit_survey';
import Survey from 'pages/main/survey';
import PatreonConnect from 'components/membership/patreon_connect';
import LearningPath from 'components/learning_path/learning_path';
import PageShow from 'pages/pages/page_show';
import PageShowBySlug from 'pages/pages/page_show_by_slug';
import CustomTabShow from 'pages/pages/custom_tab_show';
import withRouteParams from 'utils/with_route_params';

// Lazy loading wrapper with Suspense
const withSuspense = LazyComponent => {
  return props => (
    <Suspense fallback={<div>Loading...</div>}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

const creatorPages = import.meta.glob('./pages/creator/**/*.{js,jsx}');
const builderPages = import.meta.glob('./pages/builder/**/*.{js,jsx}');

function lazyRoute(section, pages, path) {
  const importer = pages[`./pages/${section}/${path}.jsx`] || pages[`./pages/${section}/${path}.js`];

  if (!importer) {
    throw new Error(`Unable to find lazy route component for pages/${section}/${path}`);
  }

  return withSuspense(withRouteParams(React.lazy(importer)));
}

const lazy = {
  creator: path => lazyRoute('creator', creatorPages, path),
  builder: path => lazyRoute('builder', builderPages, path),
};

const ForumShow = withRouteParams(ForumShowBase);
const ForumThreadCreate = withRouteParams(ForumThreadCreateBase);
const ForumThreadShow = withRouteParams(ForumThreadShowBase);

const routes = {
  routes: [{
    name: 'app',
    component: App,
    children: [{
      path: '/user/password/edit',
      name: 'user.reset_password',
      component: UserResetPassword,
      signedOutRoute: true,
      allowMemrev: true
    }, {
      path: '/trivia/decks/:deckId/user_decks/:userDeckId',
      name: 'trivia.decks.show',
      component: DeckShow
    }, {
      component: Landing,
      name: 'landing',
      path: '/',
      signedOutRoute: true,
      allowMemrev: true
    }, {
      component: Maintenance,
      name: 'maintenance',
      path: '/offline',
      allowMemrev: true
    }, {
      component: JobsIndex,
      name: 'jobs',
      path: '/jobs',
      signedOutRoute: true
    }, {
      component: JobsShow,
      name: 'jobs.show',
      path: '/jobs/:jobId',
      signedOutRoute: true
    }, {
      component: PageShow,
      name: 'memrev.home',
      path: '/pages/home',
      allowMemrev: true
    }, {
      name: 'home',
      path: '/redirect',
      component: RedirectToHome,
      allowMemrev: true
    }, {
      name: 'promotion',
      path: '/promotion/:promotionId',
      component: RedirectToHome,
      signedOutRoute: true
    }, {
      name: 'translator',
      component: Translator,
      children: [{
        component: TranslatorHome,
        name: 'translator.home',
        path: '/translator/:languageId/home'
      }, {
        component: TranslatorDecksIndex,
        name: 'translator.decks_index',
        path: '/translator/:languageId/decks'
      }, {
        component: TranslatorDecksShow,
        name: 'translator.decks_show',
        path: '/translator/:languageId/decks/:deckId'
      }, {
        component: TranslatorSentencesIndex,
        name: 'translator.sentences_index',
        path: '/translator/:languageId/sentences'
      }, {
        component: TranslatorWords,
        name: 'translator.words',
        path: '/translator/:languageId/words'
      }, {
        component: TranslatorUsers,
        name: 'translator.users',
        path: '/translator/:languageId/translators'
      }, {
        component: TranslatorUser,
        name: 'translator.user',
        path: '/translator/:languageId/translators/:userId'
      }, {
        component: ForumThreadCreate,
        name: 'translator.forum_threads.create',
        path: '/translator/:languageId/threads/create'
      }]
    }, {
      name: 'classroom',
      component: Classroom,
      children: [{
        component: ClassroomShow,
        children: [{
          component: ForumShow,
          name: 'classroom.show',
          path: '/classroom/:groupId'
        }, {
          component: ForumThreadCreate,
          name: 'classroom.forum_threads.create',
          path: '/classroom/:groupId/threads/create'
        }, {
          component: ForumThreadShow,
          name: 'classroom.forum_threads.show',
          path: '/classroom/:groupId/threads/:forumThreadId'
        }]
      }, {
        component: ClassroomProgress,
        name: 'classroom.progress',
        path: '/classroom/:groupId/progress'
      }]
    }, {
      name: 'trivia',
      component: Trivia,
      children: [{
        path: '/trivia',
        name: 'trivia.home',
        component: TriviaHome
      }, {
        path: '/trivia/progress',
        name: 'trivia.progress',
        component: TriviaProgress
      }]
    }, {
      component: VocabHome,
      children: [{
        name: 'vocab.home',
        path: '/vocab/words/page/:page',
        component: Vocab
      }, {
        name: 'vocab.progress',
        path: '/vocab/progress',
        component: VocabProgress
      }, {
        name: 'vocab.word',
        path: '/vocab/words/:wordId',
        component: VocabWord,
        allowMemrev: true
      }, {
        name: 'vocab.create',
        path: '/vocab/create',
        component: VocabCreate
      }]
    }, {
      component: Stories,
      children: [{
        name: 'stories.home',
        path: '/stories/home',
        component: StoriesHome
      }, {
        name: 'stories.show',
        path: '/topics/:treeNodeId',
        component: TreeNodeShow
      }, {
        name: 'stories.progress',
        path: '/stories/progress',
        component: StoriesProgress
      }]
    }, {
      component: Review,
      name: 'reviews',
      children: [{
        name: 'reviews.decks',
        path: '/reviews/decks',
        component: ReviewHome
      }, {
        name: 'reviews.home',
        path: '/reviews/home',
        component: ReviewHome
      }, {
        name: 'reviews.archive',
        path: '/reviews/archive',
        component: ReviewHome
      }, {
        name: 'reviews.index',
        path: '/reviews/list/page/:page',
        component: ReviewHome
      }, {
        name: 'reviews.progress',
        path: '/reviews/progress',
        component: ReviewProgress
      }, {
        name: 'reviews.show',
        path: '/reviews/card/:cardId/page/:page',
        component: ReviewShow
      }, {
        name: 'reviews.create',
        path: '/reviews/create',
        component: ReviewHome
      }]
    }, {
      name: 'league.show',
      path: '/leagues/:leagueId(/user/:userId)',
      component: LeagueShow,
      allowMemrev: true
    }, {
      component: Grammar,
      children: [{
        component: GrammarHome,
        name: 'grammar',
        path: '/grammar'
      }, {
        name: 'grammar.index',
        path: '/grammar/index',
        component: GrammarIndex
      }, {
        name: 'grammar.show',
        path: '/grammar/:grammarNodeId',
        component: GrammarHome
      }, {
        name: 'grammar.show.slug',
        path: '/grammar/:grammarNodeId/:slug',
        component: GrammarHome
      }]
    }, {
      name: 'grammar.decks.show',
      path: '/grammar/:treeNodeId/decks/:deckId',
      component: DeckShow
    }, {
      name: 'vocab.decks.show',
      path: '/vocab/decks/:deckId',
      component: DeckShow
    }, {
      name: 'triad.decks.show',
      path: '/words/:wordId/decks/:deckId',
      component: DeckShow
    }, {
      name: 'trivia.tree_nodes.decks.show',
      path: '/trivia/:treeNodeId/decks/:deckId',
      component: DeckShow
    }, {
      name: 'trivia.tree_nodes.decksWithOpponent.show',
      path: '/trivia/:treeNodeId/decks/:deckId/opponents/:opponentId',
      component: DeckShow
    }, {
      name: 'onboarding.registration',
      path: '/onboarding/registration',
      component: OnboardingRegistration,
      signedOutRoute: true,
      allowMemrev: true
    }, {
      name: 'onboarding',
      path: '/onboarding',
      component: Onboarding,
      signedOutRoute: true,
      allowMemrev: true,
      children: [{
        name: 'onboarding.sign_in',
        path: '/onboarding/sign_in',
        component: OnboardingRegistration,
        signedOutRoute: true
      }, {
        name: 'onboarding.register',
        path: '/onboarding/register',
        component: OnboardingRegistration,
        signedOutRoute: true
      }, {
        name: 'onboarding.forgot_password',
        path: '/onboarding/forgot_password',
        component: OnboardingRegistration
      }, {
        name: 'onboarding.create_password',
        path: '/onboarding/create_password',
        component: OnboardingMemrevCreatePassword
      }, {
        name: 'onboarding.migration',
        path: '/onboarding/migration',
        component: OnboardingMemrevMigration
      }, {
        name: 'onboarding.confirm',
        path: '/onboarding/confirm',
        component: OnboardingRegistration,
        signedOutRoute: true
      }, {
        name: 'onboarding.exists',
        path: '/onboarding/exists',
        component: AuthenticateExists,
        signedOutRoute: true,
        allowMemrev: true
      }]
    }, {
      name: 'onboarding',
      path: '/onboarding/:languageId',
      component: Onboarding,
      signedOutRoute: true,
      allowMemrev: true,
      children: [{
        name: 'onboarding.level',
        path: '/onboarding/:languageId/level',
        component: OnboardingLevel,
        signedOutRoute: true
      }, {
        name: 'onboarding.registration',
        path: '/onboarding/:languageId/registration',
        component: OnboardingRegistration,
        signedOutRoute: true
      }, {
        name: 'onboarding.referrer',
        path: '/onboarding/:languageId/referrer',
        component: OnboardingReferrer,
        signedOutRoute: true
      }, {
        name: 'onboarding.native_language',
        path: '/onboarding/:languageId/language',
        component: OnboardingNativeLanguage,
        signedOutRoute: true
      }, {
        name: 'onboarding.choose_deck',
        path: '/onboarding/:languageId/choose_deck',
        component: OnboardingChooseDeck,
        signedOutRoute: true
      }]
    }, {
      name: 'onboarding.patreon',
      path: '/patreon',
      component: PatreonConnect,
      allowMemrev: true
    }, {
      name: 'profile',
      path: '/profile',
      component: ProfileHome,
      allowMemrev: true
    }, {
      name: 'memberships.index',
      path: '/memberships',
      component: MembershipIndex,
      signedOutRoute: true,
      allowMemrev: true
    }, {
      name: 'memberships.change',
      path: '/memberships/change',
      component: MembershipChange,
      allowMemrev: true
    }, {
      name: 'memberships.join',
      path: '/join',
      component: MembershipIndex,
      signedOutRoute: true,
      allowMemrev: true
    }, {
      name: 'memberships.thank_you',
      path: '/memberships/thank_you',
      component: ThankYou,
      allowMemrev: true
    }, {
      name: 'memberships.create',
      path: '/memberships/:membershipId',
      component: ComponentForSeedlangOrMemrevSite(CheckoutSeedlang, CheckoutMemrev),
      allowMemrev: true
    }, ...[{
      name: 'worksheets',
      path: 'posts/:worksheetId'
    }, {
      name: 'videos',
      path: 'videos/:worksheetId'
    }, {
      name: 'podcast',
      path: 'podcast/:worksheetId'
    }, {
      name: 'learn',
      path: 'learn/:worksheetId'
    }].flatMap(item => {
      return [{
        name: `${item.name}.show`,
        path: item.path,
        component: WorksheetShow,
        allowMemrev: true,
        blockSeedlang: true,
        children: [{
          name: `${item.name}.exercises.show`,
          path: 'exercises/:exerciseId',
          component: ExerciseShow
        }, ...(item.name === 'worksheets' ? [{
          name: 'exercises.show',
          path: 'exercises/:exerciseId/:namespace',
          component: ExerciseShow
        }] : []), {
          name: `${item.name}.vocab.show`,
          path: 'vocab',
          component: WorksheetVocab
        }, {
          name: `${item.name}.info.show`,
          path: 'info',
          component: WorksheetInfo
        }, {
          name: `${item.name}.comments.show`,
          path: 'comments',
          component: WorksheetComments
        }, {
          name: `${item.name}.download_links.index`,
          path: 'extras',
          component: DownloadLinkIndex
        }, {
          name: `${item.name}.custom_tab.show`,
          path: ':customTabSlug',
          component: CustomTabShow
        }]
      }, {
        name: `${item.name}.vocab.word`,
        path: `${item.path}/vocab/:wordId`,
        component: VocabWord,
        allowMemrev: true
      }];
    }), {
      name: 'groups.show',
      path: '/groups/:groupId',
      component: GroupShow,
      allowMemrev: true,
      children: [{
        component: PodcastEpisodeShow,
        name: 'podcast_episodes.show',
        path: '/podcast_episodes/:podcastEpisodeId',
        signedOutRoute: true
      }, {
        component: PodcastEpisodeShow,
        name: 'newsletter.show',
        path: '/newsletter/:podcastEpisodeId',
        signedOutRoute: true
      }, {
        name: 'worksheets.by_filter',
        path: '/posts/filter/:filter',
        component: WorksheetIndex
      }, {
        name: 'worksheets.index',
        path: '/posts',
        component: WorksheetIndex
      }, {
        name: 'videos.index',
        path: '/videos',
        component: VideoWorksheetIndex
      }, {
        name: 'podcast.index',
        path: '/podcast',
        component: PodcastWorksheetIndex
      }, {
        name: 'learn.index',
        path: '/learn',
        component: LearningPath
      }, {
        name: 'community',
        path: '/community',
        component: Community,
        signedOutRoute: true,
        allowMemrev: true,
        blockSeedlang: true
      }, {
        name: 'exercises.index',
        path: '/exercises',
        component: ExerciseIndex
      }, {
        name: 'groups.info',
        path: '/info/:pageId',
        component: GroupInfo
      }]
    }, {
      path: '/settings',
      component: Settings,
      children: [{
        name: 'settings.all',
        path: 'all',
        allowMemrev: true
      }, {
        name: 'settings.user_profile',
        path: 'user_profile',
        component: ComponentForSeedlangOrMemrevSite(SettingsUserProfileSeedlang, SettingsUserProfileMemrev),
        allowMemrev: true
      }, {
        name: 'settings.deck',
        path: 'deck_settings',
        component: SettingsDeck
      }, {
        name: 'settings.clear_progress',
        path: 'clear_progress',
        component: SettingsClearProgress
      }, {
        name: 'settings.streak_repair',
        path: 'streak_repair',
        component: SettingsStreakRepair
      }, {
        name: 'settings.user_image',
        path: 'user_image',
        component: SettingsUserImage,
        allowMemrev: true
      }, {
        signedOutRoute: true,
        name: 'settings.user_notifications',
        path: 'user_notifications',
        component: SettingsUserNotifications,
        allowMemrev: true
      }, {
        signedOutRoute: true,
        name: 'settings.email',
        path: 'email',
        component: SettingsEmail,
        allowMemrev: true
      }, {
        name: 'settings.billing',
        path: 'billing',
        component: ComponentForSeedlangOrMemrevSite(SettingsBillingSeedlang, SettingsBillingMemrev),
        allowMemrev: true
      }, {
        name: 'settings.affiliate',
        path: 'affiliate',
        component: SettingsAffiliate
      }, {
        name: 'settings.cancel',
        path: 'subscriptions/cancel',
        component: SettingsCancel,
        allowMemrev: true
      }, {
        name: 'settings.audio_feeds',
        path: 'audio_feeds(/:podcastId)',
        component: SettingsRssFeed,
        allowMemrev: true
      }, {
        name: 'settings.password',
        path: 'password',
        component: SettingsPassword,
        allowMemrev: true
      }, {
        name: 'settings.memberships.create',
        path: 'memberships/:membershipId',
        component: ComponentForSeedlangOrMemrevSite(CheckoutSeedlang, CheckoutMemrev),
        allowMemrev: true
      }, {
        name: 'settings.privacy',
        path: 'privacy',
        component: SettingsPrivacy,
        allowMemrev: true
      }, {
        name: 'settings.page.show',
        path: 'pages/:pageId',
        component: PageShow,
        allowMemrev: true
      }],
      indexRedirects: [{
        to: '/settings/all'
      }]
    }, {
      name: 'privacy',
      path: '/privacy',
      component: Privacy,
      signedOutRoute: true
    }, {
      name: 'app',
      path: '/app',
      component: AppListing,
      signedOutRoute: true
    }, {
      name: 'partners',
      path: '/partners',
      component: Partners,
      signedOutRoute: true
    }, {
      name: 'legal',
      path: '/legal',
      component: Legal,
      signedOutRoute: true
    }, {
      name: 'terms',
      path: '/terms',
      component: Terms,
      signedOutRoute: true
    }, {
      name: 'block_notifications',
      path: '/block_notifications',
      component: BlockNotifications,
      signedOutRoute: true,
      allowMemrev: true
    }, {
      name: 'exit_survey',
      path: '/exit_survey',
      component: ExitSurvey,
      allowMemrev: true
    }, {
      name: 'survey',
      path: '/survey/:surveySlug',
      component: Survey,
      allowMemrev: true
    }, {
      name: 'faq',
      path: '/faq',
      component: Faq,
      signedOutRoute: true
    }, {
      name: 'unpublished',
      path: '/unpublished',
      component: UnpublishedMemrevHome,
      signedOutRoute: true,
      allowMemrev: true
    }, {
      name: 'access',
      path: '/access/:token',
      component: Access,
      signedOutRoute: true,
      allowMemrev: true
    }, {
      name: 'help_center',
      path: '/help_center',
      component: HelpCenter,
      signedOutRoute: true,
      allowMemrev: true
    }, {
      name: 'assign_membership_group',
      path: '/assign_membership_group/:membershipGroupId',
      component: AssignMembershipGroup,
      signedOutRoute: true
    }, {
      name: 'faq_categories.show',
      path: '/help_center/topic/:faqCategoryId',
      component: FaqCategoryShow,
      signedOutRoute: true,
      allowMemrev: true
    }, {
      name: 'faq_items.show',
      path: '/help_center/topic/:faqCategoryId/article/:faqItemId',
      component: FaqItemShow,
      signedOutRoute: true,
      allowMemrev: true
    }, {
      name: 'blog',
      path: '/blog',
      component: Blog,
      signedOutRoute: true
    }, {
      name: 'forum',
      component: Forum,
      children: [{
        name: 'forums.index',
        path: '/discussions',
        component: ForumIndex
      }, {
        name: 'forums.show',
        path: '/discussions/:forumId/page/:page',
        component: ForumShow
      }, {
        name: 'forums.forum_threads.create',
        path: '/discussions/:forumId/threads/create',
        component: ForumThreadCreate
      }, {
        name: 'forums.forum_threads.show',
        path: '/discussions/:forumId/threads/:forumThreadId',
        component: ForumThreadShow
      }]
    }, {
      name: 'team',
      path: '/team',
      component: Team,
      signedOutRoute: true
    }, {
      name: 'contact',
      path: '/contact',
      component: ComponentForSeedlangOrMemrevSite(ContactSeedlang, ContactMemrev),
      signedOutRoute: true,
      allowMemrev: true
    }, {
      name: 'account_deletion',
      path: '/account_deletion',
      component: AccountDeletion,
      signedOutRoute: true,
      allowMemrev: true
    }, {
      name: 'profiles.show',
      path: '/profile/:userId',
      component: ProfileHome
    }, {
      name: 'decks.show',
      path: 'decks/:deckId',
      component: DeckShow
    }, {
      name: 'tree_nodes.decks.show',
      path: '/topics/:treeNodeId/decks/:deckId',
      component: DeckShow
    }, {
      name: 'reviews.decks.show',
      path: '/reviews/decks/:deckId',
      component: DeckShow
    }, {
      name: 'feeds.index',
      path: '/feeds',
      component: Feed
    }, {
      name: 'my.feed',
      path: '/feeds/mine',
      component: Feed
    }, {
      name: 'followers.feed',
      path: '/feeds/following',
      component: Feed
    }, {
      name: 'feed_entry.show',
      path: '/feeds/:feedEntryId',
      component: FeedEntryShow
    }, {
      name: 'more',
      path: '/more',
      component: More,
      children: [{
        name: 'more.latest_decks',
        path: 'latest_decks',
        component: LatestDecks
      }, {
        name: 'more.comment_history',
        path: 'comment_history',
        component: CommentHistory
      }, {
        name: 'more.help_center',
        path: 'help_center',
        component: HelpCenter
      }, {
        name: 'more.faq_categories.show',
        path: 'help_center/topic/:faqCategoryId',
        component: FaqCategoryShow
      }, {
        name: 'more.faq_items.show',
        path: 'help_center/topic/:faqCategoryId/article/:faqItemId',
        component: FaqItemShow
      }, {
        name: 'more.blog',
        path: 'blog',
        component: Blog
      }, {
        name: 'more.partners',
        path: 'partners',
        component: Partners
      }, {
        name: 'more.privacy',
        path: 'privacy',
        component: Privacy
      }, {
        name: 'more.terms',
        path: 'terms',
        component: Terms
      }, {
        name: 'more.contact',
        path: 'contact',
        component: ContactSeedlang
      }]
    }, {
      name: 'classroom',
      component: BackendClassroom,
      children: [{
        name: 'classroom.dashboard',
        path: 'classroom/:groupId/dashboard',
        component: ClassroomDashboard
      }, {
        name: 'classroom.settings',
        path: 'classroom/:groupId/settings',
        component: ClassroomSettings
      }, {
        name: 'classroom.students',
        path: 'classroom/:groupId/students',
        component: ClassroomStudents
      }]
    }, {
      name: 'creator',
      path: 'creator',
      component: lazy.creator('creator'),
      allowMemrev: true,
      children: [{
        name: 'creator.groups.show',
        path: '',
        blockSeedlang: true,
        component: lazy.creator('groups/creator_sidebar_wrapper'),
        children: [{
          name: 'creator.community',
          path: 'community',
          component: lazy.creator('community_page_edit')
        }, {
          name: 'creator.exit_survey',
          path: 'exit_survey',
          component: lazy.creator('exit_survey/exit_survey_edit')
        }, {
          name: 'creator.surveys_hub',
          path: 'surveys-hub',
          component: lazy.creator('surveys/surveys_hub')
        }, {
          name: 'creator.surveys.index',
          path: 'surveys',
          component: lazy.creator('surveys/survey_index')
        }, {
          name: 'creator.surveys.edit',
          path: 'surveys/:surveySlug',
          component: lazy.creator('surveys/survey_edit')
        }, {
          name: 'creator.exercise_types.index',
          path: 'exercise_types',
          component: lazy.creator('exercise_types/exercise_type_index')
        }, {
          name: 'creator.analytics',
          path: 'analytics',
          component: lazy.creator('analytics/analytics_creator')
        }, {
          name: 'creator.upload_net_revenue',
          path: 'upload_net_revenue',
          component: lazy.creator('upload_net_revenue')
        }, {
          name: 'creator.stripe_analytics_series.index',
          path: 'stripe_analytics_series',
          component: lazy.creator('stripe_analytics_series/stripe_analytics_series_index')
        }, {
          name: 'creator.user_exercises.index',
          path: 'user_exercises',
          component: lazy.builder('user_exercises/user_exercise_index')
        }, {
          name: 'creator.admins.index',
          path: 'admins',
          component: lazy.creator('users/admins_index')
        }, {
          name: 'creator.users.index',
          path: 'users',
          component: lazy.creator('users/users_index')
        }, {
          name: 'creator.users.edit',
          path: 'users/:userId',
          component: lazy.creator('users/users_edit')
        }, {
          name: 'creator.campaign_messages.show',
          path: 'campaign_messages/:campaignMessageId',
          component: lazy.builder('campaign_messages/campaign_message_show')
        }, {
          name: 'creator.tags.index',
          path: 'tags',
          component: lazy.creator('tags/tags_index')
        }, {
          name: 'creator.concepts.index',
          path: 'concepts',
          component: lazy.creator('word_tags/word_tags_index')
        }, {
          name: 'creator.worksheets.index',
          path: 'posts',
          component: lazy.creator('worksheets/worksheet_index')
        }, {
          name: 'creator.exercises.ai',
          path: 'exercises/ai',
          component: lazy.creator('exercises/exercise_ai_review_redirect')
        }, {
          name: 'creator.exercises.index',
          path: 'exercises',
          component: lazy.creator('exercises/exercise_index_memrev')
        }, {
          name: 'creator.worksheets.edit',
          path: 'posts/:worksheetId',
          component: lazy.creator('worksheets/worksheet_edit')
        }, {
          name: 'creator.worksheet_ai_chats.index',
          path: 'posts/:worksheetId/ai_chats',
          component: lazy.creator('worksheets/worksheet_ai_chats')
        }, {
          name: 'creator.worksheet_ai_chats.show',
          path: 'posts/:worksheetId/ai_chats/:aiChatId',
          component: lazy.creator('worksheets/worksheet_ai_chats')
        }, {
          name: 'creator.vocab.edit',
          path: 'posts/:worksheetId/vocab',
          component: lazy.creator('worksheets/vocab_edit')
        }, {
          name: 'creator.exercises.edit',
          path: 'posts/:worksheetId/exercises/:exerciseId',
          component: lazy.creator('exercises/exercise_edit')
        }, {
          name: 'creator.worksheets_custom_tabs.edit',
          path: 'worksheets/:worksheetId/worksheet_custom_tabs/:worksheetCustomTabId',
          component: lazy.creator('worksheets/worksheet_custom_tab_edit')
        }, {
          name: 'creator.site_layout',
          path: 'settings',
          component: lazy.creator('site/site_layout')
        }, {
          name: 'creator.worksheet_settings',
          path: 'worksheet_settings',
          component: lazy.creator('worksheets/worksheet_settings')
        }, {
          name: 'creator.language.edit',
          path: 'language/:languageId',
          component: lazy.creator('site/site_language_edit')
        }, {
          name: 'creator.site_navigation',
          path: 'navigation',
          component: lazy.creator('site/site_navigation')
        }, {
          name: 'creator.navigation_items.edit',
          path: 'navigation_items/:navigationItemId',
          component: lazy.builder('navigation_items/navigation_item_edit')
        }, {
          name: 'creator.site_pages',
          path: 'pages',
          component: lazy.creator('site/site_page_index')
        }, {
          name: 'creator.custom_tabs',
          path: 'custom_tabs',
          component: lazy.creator('site/custom_tab_index')
        }, {
          name: 'creator.faq_categories.index',
          path: 'faq_categories',
          component: lazy.builder('faq_categories/faq_category_index')
        }, {
          name: 'creator.faq_categories.edit',
          path: 'faq_categories/:faqCategoryId',
          component: lazy.builder('faq_categories/faq_category_edit')
        }, {
          name: 'creator.faq_items.edit',
          path: 'faq_categories/:faqCategoryId/faq_items/:faqItemId',
          component: lazy.builder('faq_items/faq_item_edit')
        }, {
          name: 'creator.site_pages.edit',
          path: 'pages/:pageId/edit',
          component: lazy.creator('site/site_page_edit')
        }, {
          name: 'creator.membership_groups',
          path: 'membership_groups',
          component: lazy.creator('membership_groups/membership_group_index_memrev')
        }, {
          name: 'creator.membership_groups.edit',
          path: 'membership_groups/:membershipGroupId/edit',
          component: lazy.builder('membership_groups/membership_group_edit_memrev')
        }, {
          name: 'creator.memberships',
          path: 'memberships',
          component: lazy.creator('memberships/memberships_hub')
        }, {
          name: 'creator.memberships.edit',
          path: 'memberships/:membershipId/edit',
          component: lazy.builder('memberships/membership_edit_memrev')
        }, {
          name: 'creator.membership_types.index',
          path: 'membership_types',
          component: lazy.creator('membership_types/membership_type_index')
        }, {
          name: 'creator.membership_types.edit',
          path: 'membership_types/:membershipTypeId/edit',
          component: lazy.creator('membership_types/membership_type_edit')
        }, {
          name: 'creator.subscriptions.index',
          path: 'subscriptions',
          component: lazy.creator('subscriptions/site_subscription_index')
        }, {
          name: 'creator.subscriptions.edit',
          path: 'subscriptions/:subscriptionId/edit',
          component: lazy.builder('subscriptions/subscription_edit_memrev')
        }, {
          name: 'creator.campaign_types.index',
          path: 'campaign_types',
          component: lazy.creator('campaign_types/campaign_type_index')
        }, {
          name: 'creator.campaign_types.edit',
          path: 'campaign_types/:campaignTypeId',
          component: lazy.creator('campaign_types/campaign_type_edit')
        }, {
          name: 'creator.campaigns.edit',
          path: 'campaign_types/:campaignTypeId/campaigns/:campaignId',
          component: lazy.creator('campaigns/campaign_edit')
        }, {
          name: 'creator.emails_hub',
          path: 'emails_hub',
          component: lazy.creator('emails/emails_hub')
        }, {
          name: 'creator.emails.index',
          path: 'emails',
          component: lazy.creator('email/email_index')
        }, {
          name: 'creator.grid_items.index',
          path: 'grid_items',
          component: lazy.creator('grid_items/grid_item_index')
        }, {
          name: 'creator.grid_items.edit',
          path: 'grid_items/:gridItemId',
          component: lazy.creator('grid_items/grid_item_edit')
        }, {
          name: 'creator.learning_paths.index',
          path: 'learning_paths',
          component: lazy.creator('learning_paths/learning_path_index')
        }, {
          name: 'creator.learning_paths.edit',
          path: 'learning_paths/:learningPathId',
          component: lazy.creator('learning_paths/learning_path_edit')
        }, {
          name: 'creator.podcast_episodes.index',
          path: 'podcast_episodes',
          component: lazy.creator('podcast_episodes/podcast_episode_index')
        }, {
          name: 'creator.podcast_episodes.edit',
          path: 'podcast_episodes/:podcastEpisodeId',
          component: lazy.creator('podcast_episodes/podcast_episode_edit')
        }, {
          name: 'creator.podcasts.index',
          path: 'podcasts',
          component: lazy.creator('podcasts/podcast_index')
        }, {
          name: 'creator.podcasts.edit',
          path: 'podcasts/:podcastId',
          component: lazy.creator('podcasts/podcast_edit')
        }, {
          name: 'creator.worksheet.comments',
          path: 'comments(/page/:page)',
          component: lazy.creator('worksheets/worksheet_comments')
        }, {
          name: 'creator.exercise.ratings',
          path: 'ratings',
          component: lazy.creator('ratings/exercise_ratings_index')
        }, {
          component: ForumThreadShow,
          name: 'creator.forum_threads.show',
          path: 'threads/:forumThreadId'
        }, {
          name: 'creator.download_link_types.index',
          path: 'download_link_types',
          component: lazy.creator('download_link_types/download_link_type_index')
        }, {
          name: 'creator.download_link_types.edit',
          path: 'download_link_types/:downloadLinkTypeId',
          component: lazy.creator('download_link_types/download_link_type_edit')
        }, {
          name: 'creator.file_management',
          path: 'file_management',
          component: lazy.creator('file_management/file_management')
        }, {
          name: 'creator.uploaded_images.index',
          path: 'uploaded_images',
          component: lazy.creator('uploaded_images/uploaded_image_index')
        }, {
          name: 'creator.uploaded_audios.index',
          path: 'uploaded_audios',
          component: lazy.creator('uploaded_audios/uploaded_audio_index')
        }, {
          name: 'creator.banner_notices.index',
          path: 'banner_notices',
          component: lazy.creator('banner_notices/banner_notice_index_memrev')
        }, {
          name: 'creator.banner_notices.edit',
          path: 'banner_notices/:bannerNoticeId',
          component: lazy.builder('banner_notices/banner_notice_edit_memrev')
        }, {
          name: 'creator.notification_announcements.index',
          path: 'notifications',
          component: lazy.creator('notification_announcements/notification_announcement_index')
        }, {
          name: 'creator.notification_announcements.edit',
          path: 'notifications/:notificationAnnouncementId',
          component: lazy.creator('notification_announcements/notification_announcement_edit')
        }, {
          name: 'creator.custom_tabs.edit',
          path: 'custom_tabs/:customTabId',
          component: lazy.creator('site/custom_tab_edit')
        }, {
          name: 'creator.mailerlite_groups.index',
          path: 'mailerlite_groups',
          component: lazy.creator('mailerlite_groups/mailerlite_group_index')
        }]
      }, {
        component: lazy.creator('producer/producer_navigation'),
        allowMemrev: true,
        children: [{
          name: 'creator.producer.concepts.index',
          path: 'decks',
          component: lazy.creator('producer/producer_concept')
        }, {
          name: 'creator.producer',
          path: 'decks/:conceptId/producer',
          component: lazy.creator('producer/producer')
        }, {
          name: 'creator.producer.video_clips.index',
          path: 'video_clips',
          component: lazy.creator('video_clips/video_clips')
        }, {
          name: 'creator.producer.recording_sessions.index',
          path: 'recording_sessions',
          component: lazy.creator('recording_sessions/recording_sessions_index')
        }, {
          name: 'creator.producer.recording_sessions.show',
          path: 'recording_sessions/:recordingSessionId',
          component: lazy.creator('recording_sessions/recording_sessions_show')
        }, {
          name: 'creator.producer.sentences.index',
          path: 'sentences',
          component: lazy.creator('sentences/sentences')
        }, {
          name: 'creator.producer.words.index',
          path: 'words/page/:page',
          component: lazy.creator('words/word_index')
        }, {
          name: 'creator.sentences.edit',
          path: 'sentences/:sentenceId',
          component: lazy.creator('sentences/sentence_edit')
        }]
      }]
    }, {
      name: 'builder',
      path: 'builder',
      component: lazy.builder('builder'),
      children: [{
        name: 'dashboard',
        path: 'dashboard',
        component: lazy.builder('dashboard/dashboard'),
        children: [{
          name: 'builder.dashboard.analytics_with_month',
          path: 'analytics/year/:year/month/:month',
          component: lazy.builder('analytics/analytics_seedlang')
        }, {
          name: 'builder.dashboard.analytics',
          path: 'analytics',
          component: lazy.builder('analytics/analytics_seedlang')
        }, {
          name: 'builder.dashboard.payments',
          path: 'payments',
          component: lazy.builder('dashboard/payments_dashboard')
        }, {
          name: 'builder.dashboard.campaign_messages',
          path: 'campaign_messages',
          component: lazy.builder('dashboard/campaign_messages_dashboard')
        }, {
          name: 'builder.dashboard.exercises',
          path: 'exercises',
          component: lazy.builder('dashboard/exercises_dashboard')
        }, {
          name: 'builder.dashboard.levels',
          path: 'levels',
          component: lazy.builder('dashboard/levels_dashboard')
        }]
      }, {
        name: 'mailings',
        path: '',
        component: lazy.builder('outreach'),
        children: [{
          name: 'builder.referrer_options.index',
          path: 'referrer_options',
          component: lazy.builder('referrer_options/referrer_option_index')
        }, {
          name: 'builder.promotions.index',
          path: 'promotions',
          component: lazy.builder('promotions/promotion_index')
        }, {
          name: 'builder.promotions.edit',
          path: 'promotions/:promotionId',
          component: lazy.builder('promotions/promotion_edit')
        }, {
          name: 'builder.notifications.index',
          path: 'notifications',
          component: lazy.builder('notifications/notification_index')
        }, {
          name: 'builder.campaign_messages.index',
          path: 'campaign_messages',
          component: lazy.builder('campaign_messages/campaign_message_index')
        }, {
          name: 'builder.campaign_types.index',
          path: 'campaign_types',
          component: lazy.builder('campaign_types/campaign_type_index')
        }, {
          name: 'builder.campaign_types.edit',
          path: 'campaign_types/:campaignTypeId',
          component: lazy.builder('campaign_types/campaign_type_edit')
        }, {
          name: 'builder.campaigns.edit',
          path: 'campaign_types/:campaignTypeId/campaigns/:campaignId',
          component: lazy.builder('campaigns/campaign_edit')
        }, {
          name: 'builder.notifications.send_notification',
          path: 'notifications/send_notification',
          component: lazy.builder('notifications/send_notification')
        }, {
          name: 'builder.campaign_messages.show',
          path: 'campaign_messages/:campaignMessageId',
          component: lazy.builder('campaign_messages/campaign_message_show')
        }]
      }, {
        name: 'concepts',
        path: '',
        component: lazy.builder('concept'),
        children: [{
          name: 'builder.concepts.index',
          path: 'concepts',
          component: lazy.builder('concepts/concept_index')
        }, {
          name: 'builder.concepts.edit',
          path: 'concepts/:conceptId',
          component: lazy.builder('concepts/concept_edit')
        }, {
          name: 'builder.concept_categories.index',
          path: 'concepts_categories',
          component: lazy.builder('concept_categories/concept_category_index')
        }, {
          name: 'builder.concept_categories.edit',
          path: 'concepts_categories/:conceptCategoryId',
          component: lazy.builder('concept_categories/concept_category_edit')
        }, {
          name: 'builder.grammar_descriptions.index',
          path: 'grammar_descriptions',
          component: lazy.builder('grammar_descriptions/grammar_description_index')
        }, {
          name: 'builder.grammar_descriptions.edit',
          path: 'grammar_descriptions/:grammarDescriptionId',
          component: lazy.builder('grammar_descriptions/grammar_description_edit')
        }]
      }, {
        name: '',
        path: '',
        component: lazy.builder('deck'),
        children: [{
          name: 'builder.trees.edit',
          path: 'trees/:treeId',
          component: lazy.builder('trees/tree_edit')
        }, {
          name: 'builder.tree_modules.edit',
          path: 'trees/:treeId/tree_modules/:treeModuleId',
          component: lazy.builder('tree_modules/tree_module_edit')
        }, {
          name: 'builder.trees_modules.index',
          path: 'trees/:treeId/tree_modules',
          component: lazy.builder('tree_modules/tree_module_index')
        }, {
          name: 'builder.trees.index',
          path: 'trees',
          component: lazy.builder('trees/tree_index')
        }, {
          name: 'builder.tree_nodes.edit',
          path: 'trees/:treeId/tree_modules/:treeModuleId/tree_nodes/:treeNodeId',
          component: lazy.builder('tree_nodes/tree_node_edit')
        }, {
          name: 'builder.tree_nodes.direct_edit',
          path: 'tree_nodes/:treeNodeId',
          component: lazy.builder('tree_nodes/tree_node_edit')
        }, {
          name: 'builder.tree_nodes_without_tree.edit',
          path: 'tree_nodes/:treeNodeId',
          component: lazy.builder('tree_nodes/tree_node_edit')
        }, {
          name: 'builder.trees.concepts.edit',
          path: 'trees/:treeId/tree_modules/:treeModuleId/tree_nodes/:treeNodeId/concepts/:conceptId',
          component: lazy.builder('tree_nodes/concept_studio')
        }, {
          name: 'builder.decks.index',
          path: 'decks/page/:page',
          component: lazy.builder('decks/deck_index')
        }, {
          name: 'builder.interjections.index',
          path: 'interjections',
          component: lazy.builder('interjections/interjection_index')
        }, {
          name: 'builder.interjections.edit',
          path: 'interjections/:interjectionId',
          component: lazy.builder('interjections/interjection_edit')
        }, {
          name: 'builder.user_decks.index',
          path: 'user_decks',
          component: lazy.builder('user_decks/user_deck_index')
        }, {
          name: 'builder.decks.user_decks.index',
          path: 'decks/:deckId/user_decks',
          component: lazy.builder('user_decks/user_deck_index')
        }, {
          name: 'builder.ratings.index',
          path: 'ratings',
          component: lazy.builder('ratings/rating_index')
        }, {
          name: 'builder.ratings.edit',
          path: 'ratings/:ratingId',
          component: lazy.builder('ratings/rating_edit')
        }, {
          name: 'builder.rating_types.index',
          path: 'rating_types',
          component: lazy.builder('rating_types/rating_type_index')
        }, {
          name: 'builder.rating_types.edit',
          path: 'rating_types/:ratingTypeId',
          component: lazy.builder('rating_types/rating_type_edit')
        }, {
          name: 'builder.decks.edit',
          path: 'decks/:deckId',
          component: lazy.builder('decks/deck_edit')
        }, {
          name: 'builder.decks.reviews.index',
          path: 'users/:userId/decks/:deckId/',
          component: lazy.builder('decks/reviews_index')
        }, {
          name: 'builder.trees.decks.edit',
          path: 'trees/:treeId/tree_modules/:treeModuleId/tree_nodes/:treeNodeId/decks/:deckId',
          component: lazy.builder('decks/deck_edit')
        }, {
          name: 'builder.deck_rulebooks.index',
          path: 'deck_rulebooks',
          component: lazy.builder('deck_rulebooks/deck_rulebook_index')
        }, {
          name: 'builder.deck_rulebooks.edit',
          path: 'deck_rulebooks/:deckRulebookId',
          component: lazy.builder('deck_rulebooks/deck_rulebook_edit')
        }, {
          name: 'builder.card_types.index',
          path: 'card_types',
          component: lazy.builder('card_types/card_type_index')
        }, {
          name: 'builder.card_types.edit',
          path: 'card_types/:cardTypeId',
          component: lazy.builder('card_types/card_type_edit')
        }]
      }, {
        name: 'subscriptions',
        path: '',
        component: lazy.builder('subscription'),
        children: [{
          name: 'builder.payment_intents.index',
          path: '/payment_intents',
          component: lazy.builder('payment_intents/payment_intent_index')
        }, {
          name: 'builder.affiliate_payouts.index',
          path: '/affiliate_payouts',
          component: lazy.builder('affiliate_payouts/affiliate_payout_index')
        }, {
          name: 'builder.affiliate_payouts.show',
          path: '/affiliate_payouts/:affiliatePayoutId',
          component: lazy.builder('affiliate_payouts/affiliate_payout_show')
        }, {
          name: 'builder.subscriptions.index',
          path: 'subscriptions',
          component: lazy.builder('subscriptions/subscription_index')
        }, {
          name: 'builder.subscriptions.edit',
          path: 'subscriptions/:subscriptionId',
          component: lazy.builder('subscriptions/subscription_edit_seedlang')
        }, {
          name: 'builder.subscriptions.payments.edit',
          path: 'subscriptions/:subscriptionId/payments/:paymentId',
          component: lazy.builder('payments/payment_edit')
        }, {
          name: 'builder.payments.edit',
          path: 'payments/:paymentId',
          component: lazy.builder('payments/payment_edit')
        }, {
          name: 'builder.payments.index',
          path: 'payments',
          component: lazy.builder('payments/payment_index')
        }, {
          name: 'builder.memberships.index',
          path: 'memberships',
          component: lazy.builder('memberships/membership_index')
        }, {
          name: 'builder.memberships.edit',
          path: 'memberships/:membershipId',
          component: lazy.builder('memberships/membership_edit_seedlang')
        }, {
          name: 'builder.membership_types.index',
          path: 'membership_types',
          component: lazy.builder('membership_types/membership_type_index')
        }, {
          name: 'builder.membership_types.edit',
          path: 'membership_types/:membershipTypeId',
          component: lazy.builder('membership_types/membership_type_edit')
        }, {
          name: 'builder.membership_groups.index',
          path: 'membership_groups',
          component: lazy.builder('membership_groups/membership_group_index_seedlang')
        }, {
          name: 'builder.membership_groups.edit',
          path: 'membership_groups/:membershipGroupId',
          component: lazy.builder('membership_groups/membership_group_edit_seedlang')
        }]
      }, {
        name: 'site',
        path: '',
        component: lazy.builder('site'),
        children: [{
          name: 'builder.ai_services.index',
          path: 'ai_services',
          component: lazy.builder('ai_services/ai_service_index')
        }, {
          name: 'builder.languages.index',
          path: 'languages',
          component: lazy.builder('languages/language_index')
        }, {
          name: 'builder.banner_notices.index',
          path: 'banner_notices',
          component: lazy.builder('banner_notices/banner_notice_index_seedlang')
        }, {
          name: 'builder.banner_notices.edit',
          path: 'banner_notices/:bannerNoticeId',
          component: lazy.builder('banner_notices/banner_notice_edit_seedlang')
        }, {
          name: 'builder.groups.index',
          path: 'groups',
          component: lazy.builder('groups/group_index')
        }, {
          name: 'builder.groups.edit',
          path: 'groups/:groupId',
          component: lazy.builder('groups/group_edit')
        }, {
          name: 'builder.site.index',
          path: 'sites',
          component: lazy.builder('sites/site_index')
        }, {
          name: 'builder.site.edit',
          path: 'sites/:siteId',
          component: lazy.builder('sites/site_edit')
        }, {
          name: 'builder.page.index',
          path: 'pages',
          component: lazy.builder('pages/page_index')
        }, {
          name: 'builder.uploaded_images.index',
          path: 'uploaded_images',
          allowMemrev: true,
          component: lazy.creator('uploaded_images/uploaded_image_index')
        }, {
          name: 'builder.page.show',
          path: 'pages/:pageId',
          component: PageShow
        }, {
          name: 'builder.page.edit',
          path: 'pages/:pageId/edit',
          component: lazy.builder('pages/page_edit')
        }, {
          name: 'builder.job.index',
          path: 'jobs',
          component: lazy.builder('jobs/job_index')
        }, {
          name: 'builder.job.edit',
          path: 'jobs/:jobId/edit',
          component: lazy.builder('jobs/job_edit')
        }, {
          name: 'builder.faq_categories.index',
          path: 'faq_categories',
          component: lazy.builder('faq_categories/faq_category_index')
        }, {
          name: 'builder.faq_categories.edit',
          path: 'faq_categories/:faqCategoryId',
          component: lazy.builder('faq_categories/faq_category_edit')
        }, {
          name: 'builder.faq_items.edit',
          path: 'faq_categories/:faqCategoryId/faq_items/:faqItemId',
          component: lazy.builder('faq_items/faq_item_edit')
        }, {
          name: 'builder.site_releases.edit',
          path: 'site_release/:siteReleaseId',
          component: lazy.builder('site_releases/site_release_edit')
        }, {
          name: 'builder.site_releases.index',
          path: 'site_releases',
          component: lazy.builder('site_releases/site_release_index')
        }, {
          name: 'builder.forums.index',
          path: 'forums',
          component: lazy.builder('forums/forum_index')
        }, {
          name: 'builder.forums.edit',
          path: 'forums/:forumId',
          component: lazy.builder('forums/forum_edit')
        }, {
          name: 'builder.versions.index',
          path: 'versions',
          component: lazy.builder('versions/version_index')
        }, {
          name: 'builder.versions.show',
          path: 'versions/:versionId',
          component: lazy.builder('versions/version_show')
        }, {
          name: 'builder.team_members.index',
          path: 'team_members',
          component: lazy.builder('team_members/team_member_index')
        }, {
          name: 'builder.team_members.edit',
          path: 'team_members/:teamMemberId',
          component: lazy.builder('team_members/team_member_edit')
        }]
      }, {
        name: 'users',
        path: '',
        component: lazy.builder('user'),
        children: [{
          name: 'builder.users.index',
          path: 'users',
          component: lazy.builder('users/user_index')
        }, {
          name: 'builder.league_levels.index',
          path: 'league_levels',
          component: lazy.builder('leagues/league_levels_index')
        }, {
          name: 'builder.league_levels.edit',
          path: 'league_levels/:leagueLevelId/edit',
          component: lazy.builder('leagues/league_level_edit')
        }, {
          name: 'builder.users.edit',
          path: 'users/:userId',
          component: lazy.builder('users/user_edit')
        }, {
          name: 'builder.invitations.index',
          path: 'invitations',
          component: lazy.builder('invitations/invitation_index')
        }, {
          name: 'builder.challenges.index',
          path: 'challenges',
          component: lazy.builder('challenges/challenge_index')
        }, {
          name: 'builder.sessions.index',
          path: 'users/:userId/sessions',
          component: lazy.builder('sessions/session_index')
        }, {
          name: 'builder.contact_messages.index',
          path: 'contact_messages',
          component: lazy.builder('contact_messages/contact_message_index')
        }, {
          name: 'builder.contact_messages.show',
          path: 'contact_messages/:contactMessageId',
          component: lazy.builder('contact_messages/contact_message_show')
        }, {
          name: 'builder.comments.index',
          path: 'comments',
          component: lazy.builder('comments/comment_index')
        }, {
          name: 'builder.languages.edit',
          path: 'languages/:languageId',
          component: lazy.builder('languages/language_edit')
        }]
      }, {
        name: 'translations',
        path: '',
        component: lazy.builder('translation'),
        children: [{
          name: 'builder.video_clips.index',
          path: 'video_clips',
          component: lazy.builder('video_clips/video_clip_index')
        }, {
          name: 'builder.video_clips.edit',
          path: 'video_clips/:videoClipId',
          component: lazy.builder('video_clips/video_clip_edit')
        }, {
          name: 'builder.words.index',
          path: 'words/page/:page',
          component: lazy.builder('words/word_index')
        }, {
          name: 'builder.sentences.index',
          path: 'sentences',
          component: lazy.builder('sentences/sentence_index')
        }, {
          name: 'builder.sentences.edit',
          path: 'sentences/:sentenceId',
          component: lazy.builder('sentences/sentence_edit')
        }, {
          name: 'builder.words.edit',
          path: 'words/:wordId',
          component: lazy.builder('words/word_edit')
        }, {
          name: 'builder.sentence_submissions.index',
          path: 'sentence_submissions',
          component: lazy.builder('sentence_submissions/sentence_submission_index')
        }, {
          name: 'builder.card_submissions.index',
          path: 'card_submissions/page/:page',
          component: lazy.builder('cards/user_submission_index')
        }, {
          name: 'builder.sources.index',
          path: 'sources',
          component: lazy.builder('sources/source_index')
        }, {
          name: 'builder.translation_sources.index',
          path: 'translation_sources',
          component: lazy.builder('translation_sources/translation_source_index')
        }, {
          name: 'builder.translation_sources.edit',
          path: 'translation_sources/:translationSourceId',
          component: lazy.builder('translation_sources/translation_source_edit')
        }, {
          name: 'builder.word_types.index',
          path: 'word_types',
          component: lazy.builder('word_types/word_type_index')
        }, {
          name: 'builder.word_types.edit',
          path: 'word_types/:wordTypeId',
          component: lazy.builder('word_types/word_type_edit')
        }, {
          name: 'builder.sources.edit',
          path: 'sources/:sourceId',
          component: lazy.builder('sources/source_edit')
        }, {
          name: 'builder.targets.index',
          path: 'targets',
          component: lazy.builder('targets/target_index')
        }, {
          name: 'builder.targets.edit',
          path: 'targets/:targetId',
          component: lazy.builder('targets/target_edit')
        }, {
          name: 'builder.levels.index',
          path: 'levels',
          component: lazy.builder('levels/level_index')
        }, {
          name: 'builder.levels.edit',
          path: 'levels/:levelId',
          component: lazy.builder('levels/level_edit')
        }]
      }]
    }, {
      name: 'discord',
      path: '/discord',
      component: Discord,
      allowMemrev: true,
      signedOutRoute: true
    }, {
      name: 'page.show',
      path: 'pages/:pageId',
      component: PageShow,
      allowMemrev: true
    }, {
      name: 'page.show.slug',
      path: 'pages/slug/:slug',
      component: PageShowBySlug,
      allowMemrev: true
    }, {
      name: 'easygerman',
      path: 'easygerman',
      component: RedirectToHome
    }],
    redirects: [{
      from: 'groups/:groupId/worksheets/:worksheetId',
      to: 'posts/:worksheetId'
    }, {
      from: 'groups/:groupId/worksheets/:worksheetId/vocab',
      to: 'posts/:worksheetId/vocab'
    }, {
      from: 'groups/:groupId/worksheets/:worksheetId/comments',
      to: 'posts/:worksheetId/comments'
    }, {
      from: 'worksheets/:worksheetId',
      to: 'posts/:worksheetId'
    }, {
      from: 'worksheets/:worksheetId/vocab',
      to: 'posts/:worksheetId/vocab'
    }, {
      from: 'worksheets/:worksheetId/comments',
      to: 'posts/:worksheetId/comments'
    }, {
      from: '/site_releases',
      to: '/blog'
    }, {
      from: '*',
      to: '/redirect'
    }]
  }],
  redirects: []
};

export default routes;
